import { ECompanyType, IPageParam } from '@core/main/types/common';

/** 企业特殊配置类型 */
export enum ECompanySpecialConfigType {
  /** 海南资料收集 */
  MATCH_HN_DATUM_SELECTION = 'MATCH_HN_DATUM_SELECTION',
  /** 结算说明配置 */
  PAY_TIPS_SWITCH = 'PAY_TIPS_SWITCH',
  /** 合同签署方式--众包经营所得 */
  CROWD_BUSINESS_INCOME_SWITCH = 'CROWD_BUSINESS_INCOME_SWITCH',
  /** 合同签署方式--众包劳务报酬 */
  CROWD_LABOR_REMUNERATION_SWITCH = 'CROWD_LABOR_REMUNERATION_SWITCH',
  /** 报名审核机制--通用 */
  DUTY_SIGNUP_AUDIT_SWITCH = 'DUTY_SIGNUP_AUDIT_SWITCH',
  /** 活体验证--众包劳务报酬 */
  CROWD_LABOR_REMUNERATION_FACE_AUTH_SWITCH = 'CROWD_LABOR_REMUNERATION_FACE_AUTH_SWITCH',
}

export const companySpecialConfigTypeLabel = {
  [ECompanySpecialConfigType.MATCH_HN_DATUM_SELECTION]: '派发前海南资料收集--撮合',
  [ECompanySpecialConfigType.PAY_TIPS_SWITCH]: '支付时是否展示结算说明--通用',
  [ECompanySpecialConfigType.CROWD_BUSINESS_INCOME_SWITCH]: '合同签署方式--众包经营所得',
  [ECompanySpecialConfigType.CROWD_LABOR_REMUNERATION_SWITCH]: '合同签署方式--众包劳务报酬',
  [ECompanySpecialConfigType.DUTY_SIGNUP_AUDIT_SWITCH]: '报名审核机制--通用',
  [ECompanySpecialConfigType.CROWD_LABOR_REMUNERATION_FACE_AUTH_SWITCH]: '活体验证--众包劳务报酬',
};

/** 报名审核机制 */
export enum ERegistrationReviewMechanism {
  /** 手动审核 */
  HAND = 'manual',
  /** 自动审核 */
  AUTO = 'auto',
}

export const registrationReviewMechanismLabel = {
  [ERegistrationReviewMechanism.HAND]: '手动审核',
  [ERegistrationReviewMechanism.AUTO]: '自动审核',
};

/** 合同签署方式 */
export enum EContractSignType {
  /** 无感签约 */
  IMPLICIT = 'implicit',
  /** 线上签约 */
  ONLINE = 'online',
}

export const contractSignTypeLabel = {
  [EContractSignType.IMPLICIT]: '无感签约',
  [EContractSignType.ONLINE]: '线上签约',
};

/** 支付时是否展示结算说明 */
export enum EShowSettlementStatement {
  /** 不展示 */
  NO = 0,
  /** 展示 */
  YES = 1,
}

export const showSettlementStatementLabel = {
  [EShowSettlementStatement.NO]: '不展示',
  [EShowSettlementStatement.YES]: '展示',
};

/** 派发前海南资料收集 */
export enum EHnDataCollection {
  /** 实名状态 */
  REAL_NAME = 0,
  /** 企业绑定状态 */
  ENTERPRISE_BINDING = 1,
}

export const hnDataCollectionLabel = {
  [EHnDataCollection.REAL_NAME]: '实名状态',
  [EHnDataCollection.ENTERPRISE_BINDING]: '企业绑定状态+税务登记',
};

export interface ICompanySpecialConfigPageParam extends IPageParam {
  /** 企业名称 */
  companyName?: string;
  /** 服务商名称 */
  serverName?: string;
  /** 上级代理商名称 */
  agentName?: string;
  /** 特级代理商名称 */
  topAgentName?: string;
}

export interface ICompanySpecialConfigPage {
  /** 企业ID */
  id: number;
  /** 企业编号 */
  code: string;
  /** 企业名称 */
  companyName: string;
  /** 服务商名称 */
  serverName: string;
  /** 上级代理商名称 */
  agentName: string;
  /** 特级代理商名称 */
  topAgentName: string;
  /** 业务联系人姓名 */
  contactName: string;
  /** 企业类型(ENTERPRISE 公司 PROPRIETOR 个体户) */
  type: ECompanyType;
}

export interface ICompanySpecialConfigParam {
  /** 企业ID列表 */
  companyIdList: number[];
  companySpecialConfigDTO: IcompanySpecialConfigDTO;
}

export interface IcompanySpecialConfigDTO {
  general?: {
    /** 报名审核机制：manual（手动审核） / auto（自动审核） */
    auditMode?: ERegistrationReviewMechanism;
    /** 支付时是否展示结算说明 */
    showPaySettlement?: boolean;
  };
  bizIncome?: {
    /** 合同签署方式：implicit（无感签约） / online（线上签约） */
    contractSignType?: EContractSignType;
  };
  bizReward?: {
    /** 合同签署方式：implicit（无感签约） / online（线上签约） */
    contractSignType?: EContractSignType;
    /** 人脸认证是否启用 */
    faceAuthEnable?: EFaceAuthEnable;
  };
  matchConfig?: {
    /** 是否实名状态必填 */
    collectRealname?: boolean;
    /** 是否企业绑定状态必填 */
    collectCompanyBind?: boolean;
  };
}

/** 支付时是否展示结算说明 */
export enum EFaceAuthEnable {
  /** 否 */
  NO = 1,
  /** 是 */
  YES = 0,
}

export const faceAuthEnableLabel = {
  [EFaceAuthEnable.NO]: '否',
  [EFaceAuthEnable.YES]: '是',
};

